module.exports = __webpack_public_path__ + "img/auburn-city.cdf470ae.jpg";